"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isRSPCompToken = exports.rspCompTokens = void 0;
var accordions_1 = require("./accordions");
var alerts_1 = require("./alerts");
var avatar_1 = require("./avatar");
var avatar_group_1 = require("./avatar-group");
var badge_1 = require("./badge");
var breadcrumbs_1 = require("./breadcrumbs");
var button_group_1 = require("./button-group");
var buttons_1 = require("./buttons");
var cards_1 = require("./cards");
var checkboxes_1 = require("./checkboxes");
var chips_1 = require("./chips");
var circular_progress_1 = require("./circular-progress");
var date_picker_1 = require("./date-picker");
var dialog_content_1 = require("./dialog-content");
var dialog_footer_1 = require("./dialog-footer");
var dialog_header_1 = require("./dialog-header");
var dialogs_1 = require("./dialogs");
var dividers_1 = require("./dividers");
var drawers_1 = require("./drawers");
var dropzone_1 = require("./dropzone");
var hero_card_1 = require("./hero-card");
var info_panels_1 = require("./info-panels");
var linear_progresses_1 = require("./linear-progresses");
var list_items_1 = require("./list-items");
var lists_1 = require("./lists");
var menu_items_1 = require("./menu-items");
var menus_1 = require("./menus");
var navbar_sidebars_1 = require("./navbar-sidebars");
var navbar_topbar_1 = require("./navbar-topbar");
var paginations_1 = require("./paginations");
var poppers_1 = require("./poppers");
var radio_buttons_1 = require("./radio-buttons");
var ratings_1 = require("./ratings");
var selects_1 = require("./selects");
var sliders_1 = require("./sliders");
var snackbars_1 = require("./snackbars");
var steppers_1 = require("./steppers");
var switch_1 = require("./switch");
var tables_1 = require("./tables");
var tabs_1 = require("./tabs");
var tags_1 = require("./tags");
var text_inputs_1 = require("./text-inputs");
var tooltips_1 = require("./tooltips");
exports.rspCompTokens = __assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign({}, accordions_1.rspCompAccordionTokens), alerts_1.rspCompAlertTokens), avatar_1.rspCompAvatarTokens), badge_1.rspCompBadgeTokens), breadcrumbs_1.rspCompBreadcrumbsTokens), buttons_1.rspCompButtonTokens), button_group_1.rspCompButtonGroupTokens), cards_1.rspCompCardTokens), checkboxes_1.rspCompCheckboxTokens), chips_1.rspCompChipTokens), circular_progress_1.rspCompCircularProgressTokens), dialogs_1.rspCompDialogTokens), dividers_1.rspCompDividerTokens), drawers_1.rspCompDrawerTokens), info_panels_1.rspCompInfoPanelTokens), linear_progresses_1.rspCompLinearProgressTokens), list_items_1.rspCompListItemTokens), lists_1.rspCompListTokens), menu_items_1.rspCompMenuItemTokens), menus_1.rspCompMenuTokens), navbar_topbar_1.rspCompNavbarTopbarTokens), paginations_1.rspCompPaginationTokens), poppers_1.rspCompPopperTokens), radio_buttons_1.rspCompRadioButtonTokens), ratings_1.rspCompRatingTokens), selects_1.rspCompSelectTokens), sliders_1.rspCompSliderTokens), snackbars_1.rspCompSnackbarTokens), steppers_1.rspCompStepperTokens), switch_1.rspCompSwitchTokens), text_inputs_1.rspCompTextInputTokens), tables_1.rspCompTableTokens), tabs_1.rspCompTabsTokens), tooltips_1.rspCompTooltipToken), dialog_header_1.rspCompDialogHeaderTokens), dialog_footer_1.rspCompDialogFooterTokens), dialog_content_1.rspCompDialogContentTokens), tags_1.rspCompTagTokens), hero_card_1.rspCompHeroCardToken), avatar_group_1.rspCompAvatarGroupTokens), dropzone_1.rspCompDropzoneTokens), date_picker_1.rspCompDatePickerTokens), navbar_sidebars_1.rspCompNavbarSidebarTokens);
// eslint-disable-next-line max-len
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
var isRSPCompToken = function (tokenKey) {
    return typeof tokenKey === 'string' && Object.keys(exports.rspCompTokens).indexOf(tokenKey) > -1;
};
exports.isRSPCompToken = isRSPCompToken;
//# sourceMappingURL=comp-tokens.js.map